import { render, staticRenderFns } from "./homeIndex.vue?vue&type=template&id=7020700e&scoped=true"
import script from "./homeIndex.vue?vue&type=script&lang=js"
export * from "./homeIndex.vue?vue&type=script&lang=js"
import style0 from "./homeIndex.vue?vue&type=style&index=0&id=7020700e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7020700e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7020700e')) {
      api.createRecord('7020700e', component.options)
    } else {
      api.reload('7020700e', component.options)
    }
    module.hot.accept("./homeIndex.vue?vue&type=template&id=7020700e&scoped=true", function () {
      api.rerender('7020700e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulletinBoard/homeIndex.vue"
export default component.exports